// Выбор ресторана на вкладках «Кухни»: фильтр API и рестораны сети без iikoCloud (их выбрать нельзя).
// Рестораны с данными — сопоставленные организациям iikoCloud (/data/kitchen/restaurants); не получили
// список — выбор не ограничиваем. У одного ресторана (не сеть) ограничений нет.
import { useEffect, useMemo, useState } from 'react';
import { fetchKitchenRestaurants } from '../../services/dataService';
import { isChain, kitchenFilter, unavailableOptions } from '../../utils/restaurant';

export function useKitchenRestaurants({ available, selectedGroup, allGroups }) {
  const token = localStorage.getItem('token');
  const chain = isChain(allGroups);
  const [connected, setConnected] = useState(null); // null — не знаем

  useEffect(() => {
    if (!available || !token || !chain) return undefined;
    let alive = true;
    fetchKitchenRestaurants(token)
      .then((names) => alive && setConnected(names))
      .catch(() => alive && setConnected(null));
    return () => {
      alive = false;
    };
  }, [available, token, chain]);

  const unavailable = useMemo(() => unavailableOptions(allGroups || [], connected), [allGroups, connected]);
  // Один объект, пока не сменились выбор и «сеть или один ресторан» — для зависимостей запросов
  const filter = useMemo(() => kitchenFilter(selectedGroup, chain), [selectedGroup, chain]);
  return { filter, unavailable };
}
